const siteConfig = {
  "schemaVersion": 1,
  "meta": {
    "siteTitle": "Fernando Gonzalez Leon | Portfolio",
    "siteDescription": "Ingeniero Mecatrónico - Desarrollador de Aplicaciones",
    "ogImage": "/images/avatar.jpeg",
    "lang": "es",
    "themeColor": "#000000"
  },
  "theme": {
    "colors": {
      "bgPrimary": "#000000",
      "bgSecondary": "#1a1a2e",
      "bgTertiary": "#2d2d44",
      "textHeading": "#FFDAB9",
      "textAccent": "#DAA520",
      "textBody": "#e0e0e0",
      "textWhite": "#ffffff",
      "textMuted": "#888888",
      "divider": "#DAA520",
      "sidebarBg": "#0d0d1a",
      "sidebarHover": "#1a1a2e",
      "sidebarActive": "#DAA520"
    },
    "fonts": {
      "heading": "'Poppins', sans-serif",
      "body": "'Inter', sans-serif",
      "headingUrl": "https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700;800&display=swap",
      "bodyUrl": "https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600&display=swap"
    },
    "sizes": {
      "sidebarWidth": "220px",
      "sidebarCollapsed": "60px",
      "transitionSpeed": "0.3s"
    }
  },
  "sidebar": {
    "enabled": true,
    "position": "left",
    "width": "220px",
    "collapsedWidth": "60px",
    "backgroundColor": "",
    "textColor": "",
    "activeColor": "",
    "hoverColor": "",
    "borderColor": "",
    "brandText": "FGL",
    "brandFontSize": "2rem",
    "footerText": "FerGLDev",
    "showLanguageSwitcher": true,
    "showFooter": true,
    "showBrand": true,
    "navItems": [
      {
        "path": "/",
        "icon": "FaHome",
        "labelKey": "nav.home",
        "fontSize": "0.95rem",
        "fontWeight": "400",
        "paddingY": "0.85rem",
        "paddingX": "1.5rem",
        "marginBottom": "0px",
        "enabled": true
      },
      {
        "path": "/portfolio",
        "icon": "FaBriefcase",
        "labelKey": "nav.portfolio",
        "fontSize": "0.95rem",
        "fontWeight": "400",
        "paddingY": "0.85rem",
        "paddingX": "1.5rem",
        "marginBottom": "0px",
        "enabled": true
      },
      {
        "path": "/experience",
        "icon": "FaUserTie",
        "labelKey": "nav.experience",
        "fontSize": "0.95rem",
        "fontWeight": "400",
        "paddingY": "0.85rem",
        "paddingX": "1.5rem",
        "marginBottom": "0px",
        "enabled": true
      },
      {
        "path": "/ai-tools",
        "icon": "FaRobot",
        "labelKey": "nav.aitools",
        "fontSize": "0.95rem",
        "fontWeight": "400",
        "paddingY": "0.85rem",
        "paddingX": "1.5rem",
        "marginBottom": "0px",
        "enabled": true
      },
      {
        "path": "/contact",
        "icon": "FaEnvelope",
        "labelKey": "nav.contact",
        "fontSize": "0.95rem",
        "fontWeight": "400",
        "paddingY": "0.85rem",
        "paddingX": "1.5rem",
        "marginBottom": "0px",
        "enabled": true
      }
    ]
  },
  "socialLinks": {
    "linkedin": "https://www.linkedin.com/in/fernando-gonzalez-leon-768093248/",
    "github": "https://github.com/ferrauto",
    "email": "mailto:fernando-gonzalezleon92@outlook.com",
    "cvDownload": "/documents/cv.pdf"
  },
  "pages": {
    "home": {
      "seo": {
        "titleKey": "seo.home.title",
        "descriptionKey": "seo.home.description"
      },
      "blocks": [
        {
          "id": "home-hero",
          "type": "ProfileHero",
          "style": {
            "paddingTop": "80px",
            "paddingBottom": "40px"
          },
          "props": {
            "profileInitials": "FGL",
            "profileImage": "/images/avatar.jpeg",
            "nameKey": "home.name",
            "titleKey": "home.title",
            "bioKey": "home.bio",
            "showDivider": true,
            "ctaKey": "home.cta",
            "ctaLink": "/portfolio"
          }
        }
      ]
    },
    "portfolio": {
      "seo": {
        "titleKey": "seo.portfolio.title",
        "descriptionKey": "seo.portfolio.description"
      },
      "blocks": [
        {
          "id": "portfolio-heading",
          "type": "SectionTitle",
          "style": {},
          "props": {
            "textKey": "portfolio.heading",
            "align": "center",
            "level": "h1"
          }
        },
        {
          "id": "portfolio-pss-man",
          "type": "PortfolioItem",
          "style": {},
          "props": {
            "titleKey": "projects.pssman.title",
            "period": "2026",
            "subtitleKey": "projects.pssman.subtitle",
            "descriptionKey": "projects.pssman.description",
            "images": [
              { "url": "/images/pps_man/PSS_1.png", "alt": "PSS_MAN demo login", "id": "item_pssman_1" },
              { "url": "/images/pps_man/PSS_2.png", "alt": "PSS_MAN vault with demo entries", "id": "item_pssman_2" },
              { "url": "/images/pps_man/PSS_3.png", "alt": "PSS_MAN password generator", "id": "item_pssman_3" },
              { "url": "/images/pps_man/PSS_4.png", "alt": "PSS_MAN security settings", "id": "item_pssman_4" }
            ],
            "tags": ["Python", "Flask", "JavaScript", "Cryptography", "Raspberry Pi", "Self-hosted"],
            "links": [
              { "url": "/pss_man/privacy", "label": "Privacy policy", "id": "item_pssman_privacy" }
            ],
            "reverse": true,
            "demoSlug": "pps_man"
          }
        },
        {
          "id": "portfolio-azoni",
          "type": "PortfolioItem",
          "style": {},
          "props": {
            "titleKey": "projects.azoni.title",
            "period": "2020 – 2023",
            "subtitleKey": "projects.azoni.subtitle",
            "descriptionKey": "projects.azoni.description",
            "images": [
              {
                "url": "/images/AZ1_1.png",
                "alt": "Azoni Main screen",
                "id": "item_1772313879188_py782"
              },
              {
                "url": "/images/AZ1_2.png",
                "alt": "Azoni Left screen",
                "id": "item_1772313913073_ltk0v"
              },
              {
                "url": "/images/AZ1_3.png",
                "alt": "Azoni level selection, right screen",
                "id": "item_1772313956642_7rcx7"
              },
              {
                "url": "/images/AZ1_4.png",
                "alt": "Azoni loading screen",
                "id": "item_1772313979623_021h1"
              },
              {
                "url": "/images/AZ1_5.png",
                "alt": "Azoni stop menu",
                "id": "item_1772313999604_8ioq2"
              },
              {
                "url": "/images/AZ1_6.png",
                "alt": "Azoni Setting menu",
                "id": "item_1772314023184_tq3ew"
              },
              {
                "url": "/images/AZ1_7.png",
                "alt": "Azoni level 1",
                "id": "item_1772314046414_2ulli"
              },
              {
                "url": "/images/AZ1_8.png",
                "alt": "Azoni level 2",
                "id": "item_1772314062344_7s32l"
              },
              {
                "url": "/images/AZ1_9.png",
                "alt": "Azoni shooter level 3",
                "id": "item_1772314084964_fn8x8"
              },
              {
                "url": "/images/AZ1_10.png",
                "alt": "Azoni shooter level 3, enemies",
                "id": "item_1772314117451_x5u6m"
              },
              {
                "url": "/images/AZ1_11.png",
                "alt": "Azoni shooter level 3, ambient",
                "id": "item_1772314148183_naqv5"
              }
            ],
            "tags": [
              "Unity",
              "C#",
              "Mobile",
              "3D",
              "Education"
            ],
            "links": [
              {
                "url": "https://github.com/ProjectoAzoni/Azoni_Open",
                "label": "Repositiorio GitHub AZONI Open-Creator",
                "id": "item_1772314176054_7rfbh"
              }
            ],
            "reverse": false
          }
        },
        {
          "id": "block_1772319940921_1edxl",
          "type": "PortfolioItem",
          "style": {},
          "props": {
            "titleKey": "custom.title_mm6xjra1",
            "period": "2023",
            "subtitleKey": "custom.subtitle_mm6xkn18",
            "descriptionKey": "custom.description_mm6xl2h9",
            "images": [
              {
                "url": "/images/SK_1.jpg",
                "alt": "Skills UPC, first form",
                "id": "item_1772320116023_fjzc2"
              },
              {
                "url": "/images/SK_2.jpg",
                "alt": "Skills UPC, first form, footer",
                "id": "item_1772320146384_yqbfw"
              },
              {
                "url": "/images/SK_3.jpg",
                "alt": "Skills UPC, seconf form",
                "id": "item_1772320173115_su7k0"
              },
              {
                "url": "/images/SK_4.jpg",
                "alt": "Skills UPC, login",
                "id": "item_1772320197325_bqx18"
              },
              {
                "url": "/images/SK_5.jpeg",
                "alt": "Skills UPC, password recovery",
                "id": "item_1772320240812_suug3"
              },
              {
                "url": "/images/SK_6.png",
                "alt": "Skills UPC, admin page",
                "id": "item_1772320271136_90hbe"
              },
              {
                "url": "/images/SK_7.jpeg",
                "alt": "Skills UPC, admon page, shot 2",
                "id": "item_1772320295434_d31v2"
              }
            ],
            "tags": [
              "Bootstrap",
              "HTML",
              "CSS",
              "JavaScript",
              "Express.js",
              "Node.js",
              "MySQL"
            ],
            "links": [],
            "reverse": true
          }
        },
        {
          "id": "portfolio-azoni-terb",
          "type": "PortfolioItem",
          "style": {},
          "props": {
            "titleKey": "projects.azoni-terb.title",
            "period": "2023 – 2024",
            "subtitleKey": "projects.azoni-terb.subtitle",
            "descriptionKey": "projects.azoni-terb.description",
            "images": [
              {
                "url": "/images/AZ2_1.jpg",
                "alt": "Azoni Terb main menu",
                "id": "item_1772319265016_oxrsp"
              },
              {
                "url": "/images/AZ2_2.jpg",
                "alt": "Azoni Terb map, levels 0 and 1",
                "id": "item_1772319290601_oxb3s"
              },
              {
                "url": "/images/AZ2_3.jpg",
                "alt": "Azoni Terb map, levels 1 and 2",
                "id": "item_1772319292183_9n09d"
              },
              {
                "url": "/images/AZ2_4.jpg",
                "alt": "Azoni Terb map, level 3 and 4",
                "id": "item_1772319292580_q6dwy"
              },
              {
                "url": "/images/AZ2_5.jpg",
                "alt": "Azoni Terb map, levels 5 and 6",
                "id": "item_1772319293014_8yk77"
              },
              {
                "url": "/images/AZ2_6.jpg",
                "alt": "Azoni Terb map, levels 7 and 8",
                "id": "item_1772319293419_d0fc3"
              },
              {
                "url": "/images/AZ2_7.jpg",
                "alt": "Azoni Terb map, levlels 9 and 10",
                "id": "item_1772319293884_5sb6b"
              },
              {
                "url": "/images/AZ2_8.jpg",
                "alt": "Azoni Terb loading screen",
                "id": "item_1772319294230_q093r"
              },
              {
                "url": "/images/AZ2_9.jpg",
                "alt": "Azoni Terb level lessons",
                "id": "item_1772319294522_oqw5b"
              },
              {
                "url": "/images/AZ2_10.jpg",
                "alt": "Azoni Terb level 3 and 4, shot 1",
                "id": "item_1772319294830_bvs4j"
              },
              {
                "url": "/images/AZ2_11.jpg",
                "alt": "Azoni Terb level 3 and 4, shot 2",
                "id": "item_1772319295160_eyewh"
              },
              {
                "url": "/images/AZ2_12.jpg",
                "alt": "Azoni Terb level 5",
                "id": "item_1772319295459_gu9ld"
              },
              {
                "url": "/images/AZ2_13.jpg",
                "alt": "Azoni Terb level 6, shot 1",
                "id": "item_1772319295714_ee05c"
              },
              {
                "url": "/images/AZ2_14.jpg",
                "alt": "Azoni Terb level 6, shot 2",
                "id": "item_1772319296022_2n8y1"
              },
              {
                "url": "/images/AZ2_15.jpg",
                "alt": "Azoni Terb last level, part 1",
                "id": "item_1772319296330_4dwyb"
              },
              {
                "url": "/images/AZ2_16.jpg",
                "alt": "Azoni Terb last level, part 2",
                "id": "item_1772319296742_d53ph"
              },
              {
                "url": "/images/AZ2_17.jpg",
                "alt": "Azoni Terb last level, part 3",
                "id": "item_1772319297035_1q66t"
              },
              {
                "url": "/images/AZ2_18.jpg",
                "alt": "Azoni Terb last level, Boss fight, shot 1",
                "id": "item_1772319297417_l5z2k"
              },
              {
                "url": "/images/AZ2_19.jpg",
                "alt": "Azoni Terb last level, Boss fight, shot 2",
                "id": "item_1772319297919_vfces"
              }
            ],
            "tags": [
              "Unity",
              "C#",
              "Mobile",
              "2D",
              "Education"
            ],
            "links": [
              {
                "url": "https://play.google.com/store/apps/details?id=com.Unipiloto.AZONITERB&pcampaignid=web_share",
                "label": "Play store",
                "id": "item_1772316375134_cqblg"
              },
              {
                "url": "https://apps.apple.com/co/app/azoni/id6478449108",
                "label": "App Store",
                "id": "item_1772316810334_ov8ec"
              }
            ],
            "reverse": false
          }
        },
        {
          "id": "portfolio-touch-the-box",
          "type": "PortfolioItem",
          "style": {},
          "props": {
            "titleKey": "projects.touch-the-box.title",
            "period": "",
            "subtitleKey": "projects.touch-the-box.subtitle",
            "descriptionKey": "projects.touch-the-box.description",
            "images": [
              {
                "url": "/images/TB_1.png",
                "alt": "Touch the box, logo",
                "id": "item_1772319817881_u7xl4"
              },
              {
                "url": "/images/TB_2.jpg",
                "alt": "Touch the box, main menu",
                "id": "item_1772319833383_ux7io"
              },
              {
                "url": "/images/TB_3.jpg",
                "alt": "Touch the box, info menu",
                "id": "item_1772319863730_cgbhn"
              },
              {
                "url": "/images/TB_4.jpg",
                "alt": "Touch the box, game",
                "id": "item_1772319887865_ss3n7"
              },
              {
                "url": "/images/TB_5.jpg",
                "alt": "Touch the box, pause menu",
                "id": "item_1772319918490_vc0wy"
              }
            ],
            "tags": [
              "Unity",
              "C#",
              "Mobile",
              "Published"
            ],
            "links": [
              {
                "url": "https://play.google.com/store/apps/details?id=com.FerGL_Dev.TouchTheBox&pcampaignid=web_share",
                "label": "Play store",
                "id": "item_1772319806675_2wxve"
              }
            ],
            "reverse": true
          }
        }
      ]
    },
    "experience": {
      "seo": {
        "titleKey": "seo.experience.title",
        "descriptionKey": "seo.experience.description"
      },
      "blocks": [
        {
          "id": "exp-heading",
          "type": "SectionTitle",
          "style": {},
          "props": {
            "textKey": "experience.heading",
            "align": "center",
            "level": "h1"
          }
        },
        {
          "id": "exp-timeline",
          "type": "Timeline",
          "style": {
            "marginBottom": "4rem"
          },
          "props": {
            "items": [
              {
                "id": "exp-item-1",
                "roleKey": "experience.item1.role",
                "companyKey": "experience.item1.company",
                "period": "Sept 2025 – Presente",
                "descriptionKey": "experience.item1.description"
              },
              {
                "id": "exp-item-2",
                "roleKey": "experience.item2.role",
                "companyKey": "experience.item2.company",
                "period": "Abr 2023 - Dic 2024",
                "descriptionKey": "experience.item2.description"
              },
              {
                "id": "item_1772320709866_yj5tx",
                "roleKey": "custom.role_mm6y6u3p",
                "companyKey": "custom.company_mm6y5uzp",
                "period": "Mar 2023 - Abr 2023",
                "descriptionKey": "custom.description_mm6y6nbb"
              },
              {
                "id": "item_1772320721214_kbq0n",
                "roleKey": "custom.role_mm6y0lbl",
                "companyKey": "custom.company_mm6y2c7d",
                "period": "Nov 2022 - May 2023",
                "descriptionKey": "custom.description_mm6y3wp7"
              }
            ]
          }
        },
        {
          "id": "exp-cert-heading",
          "type": "SectionTitle",
          "style": {},
          "props": {
            "textKey": "experience.certHeading",
            "align": "center"
          }
        },
        {
          "id": "exp-certs",
          "type": "CertificateGrid",
          "style": {},
          "props": {
            "items": [
              {
                "id": "cert-1",
                "titleKey": "experience.cert1.title",
                "issuerKey": "experience.cert1.issuer",
                "date": "",
                "link": ""
              }
            ]
          }
        }
      ]
    },
    "aiTools": {
      "seo": {
        "titleKey": "seo.aitools.title",
        "descriptionKey": "seo.aitools.description"
      },
      "blocks": [
        {
          "id": "aitools-heading",
          "type": "SectionTitle",
          "style": {},
          "props": {
            "textKey": "aitools.heading",
            "align": "center",
            "level": "h1"
          }
        },
        {
          "id": "aitools-intro",
          "type": "TextBlock",
          "style": {
            "marginBottom": "1rem"
          },
          "props": {
            "contentKey": "aitools.intro",
            "align": "center"
          }
        },
        {
          "id": "aitools-toggle",
          "type": "EditModeToggle",
          "style": {
            "marginBottom": "3rem"
          },
          "props": {}
        },
        {
          "id": "aitools-pomodoro",
          "type": "PomodoroTimer",
          "style": {},
          "props": {
            "titleKey": "aitools.pomodoro.title",
            "descKey": "aitools.pomodoro.desc"
          }
        },
        {
          "id": "aitools-separator",
          "type": "Separator",
          "style": {
            "marginTop": "3rem",
            "marginBottom": "3rem"
          },
          "props": {
            "width": "60px",
            "height": "2px",
            "align": "center"
          }
        },
        {
          "id": "aitools-meapp",
          "type": "FeatureCards",
          "style": {},
          "props": {
            "titleKey": "aitools.meapp.title",
            "descKey": "aitools.meapp.desc",
            "features": [
              {
                "icon": "FaTshirt",
                "titleKey": "aitools.meapp.f1.title",
                "descKey": "aitools.meapp.f1.desc"
              },
              {
                "icon": "FaDumbbell",
                "titleKey": "aitools.meapp.f2.title",
                "descKey": "aitools.meapp.f2.desc"
              },
              {
                "icon": "FaFireAlt",
                "titleKey": "aitools.meapp.f3.title",
                "descKey": "aitools.meapp.f3.desc"
              },
              {
                "icon": "FaWifi",
                "titleKey": "aitools.meapp.f4.title",
                "descKey": "aitools.meapp.f4.desc"
              }
            ]
          }
        },
        {
          "id": "aitools-techstack",
          "type": "TechStack",
          "style": {},
          "props": {
            "labelKey": "aitools.meapp.techLabel",
            "items": [
              {
                "icon": "FaReact",
                "label": "React Native"
              },
              {
                "icon": "SiExpo",
                "label": "Expo"
              },
              {
                "icon": "SiTypescript",
                "label": "TypeScript"
              },
              {
                "icon": "SiFirebase",
                "label": "Firebase"
              },
              {
                "icon": "FaDatabase",
                "label": "Zustand"
              },
              {
                "icon": "FaMobileAlt",
                "label": "Mobile"
              }
            ]
          }
        }
      ]
    },
    "contact": {
      "seo": {
        "titleKey": "seo.contact.title",
        "descriptionKey": "seo.contact.description"
      },
      "blocks": [
        {
          "id": "contact-heading",
          "type": "SectionTitle",
          "style": {},
          "props": {
            "textKey": "contact.heading",
            "align": "center",
            "level": "h1"
          }
        },
        {
          "id": "contact-links",
          "type": "ContactLinks",
          "style": {},
          "props": {
            "subtitleKey": "contact.subtitle",
            "showDownload": false,
            "downloadKey": "contact.download",
            "items": [
              {
                "icon": "FaLinkedin",
                "labelKey": "contact.linkedin",
                "linkKey": "linkedin",
                "url": "https://www.linkedin.com/in/fernando-gonzalez-leon-768093248/"
              },
              {
                "icon": "FaGithub",
                "labelKey": "contact.github",
                "linkKey": "github",
                "url": "https://github.com/ferrauto"
              },
              {
                "icon": "FaEnvelope",
                "labelKey": "contact.email",
                "linkKey": "email",
                "url": "mailto:fernando-gonzalezleon92@outlook.com"
              }
            ]
          }
        }
      ]
    }
  },
  "i18n": {
    "es": {
      "seo.home.title": "Fernando Gonzalez Leon | Desarrollador de Software",
      "seo.home.description": "Ingeniero mecatrónico y desarrollador de software especializado en aplicaciones web, móviles y soluciones con inteligencia artificial.",
      "seo.portfolio.title": "Fernando Gonzalez Leon | Portafolio",
      "seo.portfolio.description": "Proyectos destacados en desarrollo de videojuegos educativos, aplicaciones web full stack y soluciones móviles.",
      "seo.experience.title": "Fernando Gonzalez Leon | Experiencia Profesional",
      "seo.experience.description": "Experiencia en desarrollo de software, integración de IA y creación de videojuegos educativos.",
      "seo.aitools.title": "Fernando Gonzalez Leon | Herramientas con IA",
      "seo.aitools.description": "Proyectos y herramientas desarrollados integrando inteligencia artificial en flujos de trabajo reales.",
      "seo.contact.title": "Fernando Gonzalez Leon | Contacto",
      "seo.contact.description": "Conecta conmigo para oportunidades laborales, colaboraciones o consultas profesionales.",
      "nav.home": "Inicio",
      "nav.portfolio": "Portafolio",
      "nav.experience": "Experiencia",
      "nav.aitools": "AI Tools",
      "nav.contact": "Contacto",
      "home.name": "Fernando Gonzalez Leon",
      "home.title": "Ingeniero Mecatrónico & Desarrollador de Software",
      "home.bio": "Desarrollador de software con formación en ingeniería mecatrónica. Especializado en aplicaciones web, móviles y de escritorio con experiencia en integración de inteligencia artificial, desarrollo de videojuegos y arquitecturas full stack.",
      "home.cta": "Ver Mi Trabajo",
      "portfolio.heading": "Portafolio",
      "demo.tryLive": "Pruébalo en vivo",
      "demo.badge": "Demo · datos ficticios",
      "demo.reset": "Reiniciar",
      "demo.openNewTab": "Abrir en otra pestaña",
      "demo.close": "Cerrar demo",
      "demo.loading": "Cargando demo…",
      "projects.pssman.title": "PSS_MAN",
      "projects.pssman.subtitle": "Gestor de contraseñas autoalojado",
      "projects.pssman.description": "Gestor de contraseñas multiusuario que diseñé para ejecutarse en una Raspberry Pi en casa, accesible por la red local o Tailscale. Cada bóveda se cifra con Argon2id y AES-GCM, el inicio de sesión admite TOTP y dispositivos de confianza, y los administradores gestionan usuarios y roles. Incluye generador de contraseñas, copias de seguridad cifradas con recordatorios, español/inglés, temas claro y oscuro y una extensión de autocompletado para Chrome. La demo en vivo ejecuta la interfaz real con datos ficticios en el navegador.",
      "projects.azoni.title": "AZONI",
      "projects.azoni.subtitle": "Semillero Open Creator — Universidad Piloto de Colombia",
      "projects.azoni.description": "Diseñé y desarrollé un FPS 3D educativo para dispositivos móviles enfocado en la enseñanza del reciclaje. Implementé mecánicas de juego, sistemas de niveles, UI/UX y optimización de rendimiento utilizando Unity y C#.",
      "projects.azoni-terb.title": "AZONI TERB",
      "projects.azoni-terb.subtitle": "Proyecto T.E.R.B. — Universidad Piloto de Colombia",
      "projects.azoni-terb.description": "Desarrollé un videojuego educativo 2D para el proyecto de investigación T.E.R.B., publicado exitosamente en Google Play Store y App Store. Implementé mecánicas de juego, sistema de niveles progresivos y contenido educativo interactivo.",
      "projects.touch-the-box.title": "TOUCH THE BOX",
      "projects.touch-the-box.subtitle": "Publicado en Google Play Store",
      "projects.touch-the-box.description": "Videojuego móvil de reflejos publicado independientemente en la Google Play Store. Desarrollé la mecánica de juego completa, sistema de puntuación y diseño de interfaz utilizando Unity y C#.",
      "experience.heading": "Experiencia",
      "experience.certHeading": "Certificaciones",
      "experience.item1.role": "Desarrollador Junior",
      "experience.item1.company": "Dynamic Modular Systems (DMS)",
      "experience.item1.description": "Implementé sistemas de inteligencia artificial utilizando técnicas de RAG, herramientas de IA, MCP y APIs REST para integrar capacidades de IA en aplicaciones corporativas.\nDesarrollé y desplegué APIs escalables para sistemas de chat con contexto conversacional potenciados por IA.\nContribuí a la modernización de la infraestructura tecnológica de la empresa mediante soluciones basadas en IA.",
      "experience.item2.role": "Desarrollador Junior de Videojuegos",
      "experience.item2.company": "Semillero Open Creator — Universidad Piloto de Colombia",
      "experience.item2.description": "Logré el despliegue exitoso de la aplicación en tiendas móviles (Google Play y App Store) con cero reportes de errores críticos gracias a programación basada en pruebas.\nDesarrollé mecánicas de juego, interfaz de usuario, animaciones, niveles y formularios utilizando Unity, C# y Firebase.\nParticipé en reuniones diarias bajo metodología SCRUM, siendo responsable de la depuración de código, conceptualización de ideas y redacción de informes técnicos mensuales.",
      "experience.cert1.title": "Unity Android Game Development: Build 7 2D & 3D Games",
      "experience.cert1.issuer": "Udemy",
      "certificate.viewLink": "Ver Certificado",
      "notfound.title": "Página no encontrada",
      "aitools.heading": "Herramientas con IA",
      "aitools.intro": "Proyectos construidos integrando inteligencia artificial en el flujo de desarrollo, demostrando mi capacidad para adoptar y aplicar tecnologías de IA en soluciones reales.",
      "aitools.editToggle": "Editar Mi Página",
      "aitools.pomodoro.title": "Pomodoro Timer",
      "aitools.pomodoro.desc": "Temporizador de productividad con ciclos de trabajo y descanso configurables. Diseñado para optimizar sesiones de enfoque con intervalos de 25 minutos de trabajo y 5 de descanso.",
      "aitools.meapp.title": "me_app — Personal Life Tracker",
      "aitools.meapp.desc": "Aplicación móvil completa para el seguimiento y gestión de la vida personal. Desarrollada con React Native y Firebase, cuenta con sincronización en tiempo real y arquitectura offline-first.",
      "aitools.meapp.f1.title": "Clothing Tracker",
      "aitools.meapp.f1.desc": "Gestión de prendas con documentación fotográfica y estadísticas de uso detalladas",
      "aitools.meapp.f2.title": "Workout Tracker",
      "aitools.meapp.f2.desc": "Más de 40 ejercicios integrados con plantillas personalizables y seguimiento de sesiones",
      "aitools.meapp.f3.title": "Real-time Sync",
      "aitools.meapp.f3.desc": "Sincronización multi-dispositivo en tiempo real con Firebase",
      "aitools.meapp.f4.title": "Offline-first",
      "aitools.meapp.f4.desc": "Caché local con SQLite y sincronización automática en la nube",
      "aitools.meapp.techLabel": "Tech Stack",
      "contact.heading": "Contacto",
      "contact.subtitle": "Abierto a oportunidades laborales y colaboraciones. Conectemos.",
      "contact.download": "Descargar CV",
      "contact.linkedin": "LinkedIn",
      "contact.github": "GitHub",
      "contact.email": "Email",
      "editor.playgroundBanner": "Playground",
      "editor.adminBanner": "Modo Administrador",
      "editor.general": "General",
      "editor.block": "Bloque",
      "editor.outline": "Esquema",
      "editor.colors": "Colores",
      "editor.fonts": "Fuentes",
      "editor.images": "Imágenes",
      "editor.headingFont": "Fuente de Títulos",
      "editor.bodyFont": "Fuente del Texto",
      "editor.profilePhoto": "Foto de Perfil",
      "editor.layoutStyle": "Diseño y Estilo",
      "editor.content": "Contenido",
      "editor.save": "Guardar",
      "editor.apply": "Aplicar",
      "editor.reset": "Reiniciar",
      "editor.cancel": "Cancelar",
      "editor.export": "Exportar",
      "editor.import": "Importar",
      "editor.sidebarSettings": "Barra Lateral",
      "editor.exit": "Salir del modo de edición",
      "editor.undo": "Deshacer",
      "editor.redo": "Rehacer",
      "editor.addBlockHere": "Agregar bloque aquí",
      "editor.moveUp": "Mover bloque hacia arriba",
      "editor.moveDown": "Mover bloque hacia abajo",
      "editor.duplicate": "Duplicar bloque",
      "editor.delete": "Eliminar bloque",
      "editor.selectBlock": "Seleccionar",
      "editor.reorderBlock": "Reordenar bloque: mantén presionado y arrastra",
      "editor.blockDeleted": "Bloque eliminado",
      "editor.outlineEmpty": "Esta página aún no tiene bloques.",
      "editor.noBlockSelected": "Toca un bloque en la página para editarlo",
      "editor.resetTitle": "¿Reiniciar todo?",
      "editor.resetMessage": "Esto descarta todos los cambios y no se puede deshacer.",
      "editor.imageInstructions": "Agrega el archivo a public/images/ y recarga la página para verlo.",
      "editor.unsupportedBrowser": "La edición requiere un navegador móvil más reciente. Abre esta página en una computadora o actualiza tu navegador para probarla.",
      "editor.importParseError": "Ese archivo no es JSON válido. No se realizó ningún cambio.",
      "editor.importShapeError": "Ese JSON no es una configuración de sitio válida — necesita meta, theme (colors, fonts, sizes), al menos una página, i18n.es y sidebar. No se realizó ningún cambio.",
      "editor.storageError": "No se pudo escribir en el almacenamiento del navegador — la configuración puede ser demasiado grande o el almacenamiento está bloqueado. No se realizó ningún cambio.",
      "editor.pickBlock": "Agregar un bloque",
      "editor.close": "Cerrar",
      "editor.categoryAll": "Todos",
      "editor.categoryText": "Texto",
      "editor.categoryContent": "Contenido",
      "editor.categoryMedia": "Multimedia",
      "editor.categoryLayout": "Diseño",
      "editor.categoryInteractive": "Interactivo",
      "editor.panelLabel": "Editor",
      "editor.expandCollapse": "Expandir o contraer el editor",
      "custom.title_mm6xjra1": "SKILLS UNIPILOTO",
      "custom.subtitle_mm6xkn18": "Universidad Piloto de Colombia",
      "custom.description_mm6xl2h9": "Desarrollé un aplicativo web completo para la obtención, visualización y gestión de datos de usuario, entregando una solución funcional con panel de administración en un mes.",
      "custom.role_mm6y0lbl": "Practicante — Desarrollador",
      "custom.company_mm6y2c7d": "Universidad Piloto de Colombia",
      "custom.description_mm6y3wp7": "Desarrollé funcionalidades clave del videojuego incluyendo opciones de usuario, menús, mecánicas de juego, animaciones y refactorización de código en Unity con C#.\nCorregí errores heredados del proyecto y realicé las primeras pruebas exitosas en dispositivos móviles.\nElaboré informes técnicos y working papers documentando el progreso del proyecto.",
      "custom.company_mm6y5uzp": "Universidad Piloto de Colombia",
      "custom.description_mm6y6nbb": "Desarrollé en un mes un aplicativo web funcional con sistema de búsqueda, gestión y visualización de datos.\nImplementé un panel de control con sistema de autenticación y roles para administradores y gestores utilizando HTML, CSS, React, Node.js, Express.js y MySQL.",
      "custom.role_mm6y6u3p": "Desarrollador Web Full Stack"
    },
    "en": {
      "seo.home.title": "Fernando Gonzalez Leon | Software Developer",
      "seo.home.description": "Mechatronics engineer and software developer specializing in web, mobile applications and AI-powered solutions.",
      "seo.portfolio.title": "Fernando Gonzalez Leon | Portfolio",
      "seo.portfolio.description": "Featured projects in educational game development, full stack web applications and mobile solutions.",
      "seo.experience.title": "Fernando Gonzalez Leon | Professional Experience",
      "seo.experience.description": "Professional experience in software development, AI integration and educational game development.",
      "seo.aitools.title": "Fernando Gonzalez Leon | AI-Powered Tools",
      "seo.aitools.description": "Projects and tools built by integrating artificial intelligence into real-world workflows.",
      "seo.contact.title": "Fernando Gonzalez Leon | Contact",
      "seo.contact.description": "Connect with me for job opportunities, collaborations or professional inquiries.",
      "nav.home": "Home",
      "nav.portfolio": "Portfolio",
      "nav.experience": "Experience",
      "nav.aitools": "AI Tools",
      "nav.contact": "Contact",
      "home.name": "Fernando Gonzalez Leon",
      "home.title": "Mechatronics Engineer & Software Developer",
      "home.bio": "Software developer with a mechatronics engineering background. Specialized in web, mobile and desktop applications with hands-on experience in AI integration, game development and full stack architectures.",
      "home.cta": "View My Work",
      "portfolio.heading": "Portfolio",
      "demo.tryLive": "Try it live",
      "demo.badge": "Demo · fake data",
      "demo.reset": "Reset",
      "demo.openNewTab": "Open in new tab",
      "demo.close": "Close demo",
      "demo.loading": "Loading demo…",
      "projects.pssman.title": "PSS_MAN",
      "projects.pssman.subtitle": "Self-hosted password manager",
      "projects.pssman.description": "A multi-user password manager I designed to run on a Raspberry Pi at home, reached over the LAN or Tailscale. Each vault is encrypted with Argon2id and AES-GCM, login supports TOTP and trusted devices, and admins manage users and roles. It includes a password generator, encrypted backups with reminders, English/Spanish, light and dark themes, and a Chrome autofill extension. The live demo runs the real interface against fake data in your browser.",
      "projects.azoni.title": "AZONI",
      "projects.azoni.subtitle": "Open Creator Research Group — Universidad Piloto de Colombia",
      "projects.azoni.description": "Designed and developed a 3D educational FPS for mobile devices focused on teaching recycling practices. Implemented game mechanics, level systems, UI/UX and performance optimization using Unity and C#.",
      "projects.azoni-terb.title": "AZONI TERB",
      "projects.azoni-terb.subtitle": "T.E.R.B. Research Project — Universidad Piloto de Colombia",
      "projects.azoni-terb.description": "Developed a 2D educational game for the T.E.R.B. research project, successfully published on both Google Play Store and App Store. Implemented game mechanics, progressive level systems and interactive educational content.",
      "projects.touch-the-box.title": "TOUCH THE BOX",
      "projects.touch-the-box.subtitle": "Published on Google Play Store",
      "projects.touch-the-box.description": "Independently published reflex-based mobile game on the Google Play Store. Developed the complete game mechanics, scoring system and interface design using Unity and C#.",
      "experience.heading": "Experience",
      "experience.certHeading": "Certifications",
      "experience.item1.role": "Junior Developer",
      "experience.item1.company": "Dynamic Modular Systems (DMS)",
      "experience.item1.description": "Implemented AI-powered systems using RAG techniques, AI tooling, MCP and REST APIs to integrate AI capabilities into enterprise applications.\nDeveloped and deployed scalable APIs for AI-powered chat systems with conversational context.\nContributed to modernizing the company's technology infrastructure through AI-driven solutions.",
      "experience.item2.role": "Junior Game Developer",
      "experience.item2.company": "Open Creator Research Group — Universidad Piloto de Colombia",
      "experience.item2.description": "Achieved successful deployment to mobile app stores (Google Play and App Store) with zero critical bug reports through test-driven development practices.\nDeveloped game mechanics, user interfaces, animations, levels and forms using Unity, C# and Firebase.\nParticipated in daily stand-ups under SCRUM methodology, responsible for code debugging, idea conceptualization and monthly technical report writing.",
      "experience.cert1.title": "Unity Android Game Development: Build 7 2D & 3D Games",
      "experience.cert1.issuer": "Udemy",
      "certificate.viewLink": "View Certificate",
      "notfound.title": "Page not found",
      "aitools.heading": "AI-Powered Tools",
      "aitools.intro": "Projects built by integrating artificial intelligence into the development workflow, showcasing my ability to adopt and apply AI technologies in real-world solutions.",
      "aitools.editToggle": "Edit My Page",
      "aitools.pomodoro.title": "Pomodoro Timer",
      "aitools.pomodoro.desc": "Configurable productivity timer with work and break cycles. Designed to optimize focus sessions with 25-minute work intervals and 5-minute breaks.",
      "aitools.meapp.title": "me_app — Personal Life Tracker",
      "aitools.meapp.desc": "Comprehensive mobile application for personal life tracking and management. Built with React Native and Firebase, featuring real-time synchronization and offline-first architecture.",
      "aitools.meapp.f1.title": "Clothing Tracker",
      "aitools.meapp.f1.desc": "Wardrobe management with photo documentation and detailed usage statistics",
      "aitools.meapp.f2.title": "Workout Tracker",
      "aitools.meapp.f2.desc": "40+ built-in exercises with customizable templates and session tracking",
      "aitools.meapp.f3.title": "Real-time Sync",
      "aitools.meapp.f3.desc": "Multi-device real-time synchronization with Firebase",
      "aitools.meapp.f4.title": "Offline-first",
      "aitools.meapp.f4.desc": "Local SQLite cache with automatic cloud sync when connected",
      "aitools.meapp.techLabel": "Tech Stack",
      "contact.heading": "Contact",
      "contact.subtitle": "Open to job opportunities and collaborations. Let's connect.",
      "contact.download": "Download CV",
      "contact.linkedin": "LinkedIn",
      "contact.github": "GitHub",
      "contact.email": "Email",
      "editor.playgroundBanner": "Playground",
      "editor.adminBanner": "Admin Mode",
      "editor.general": "General",
      "editor.block": "Block",
      "editor.outline": "Outline",
      "editor.colors": "Colors",
      "editor.fonts": "Fonts",
      "editor.images": "Images",
      "editor.headingFont": "Heading Font",
      "editor.bodyFont": "Body Font",
      "editor.profilePhoto": "Profile Photo",
      "editor.layoutStyle": "Layout & Style",
      "editor.content": "Content",
      "editor.save": "Save",
      "editor.apply": "Apply",
      "editor.reset": "Reset",
      "editor.cancel": "Cancel",
      "editor.export": "Export",
      "editor.import": "Import",
      "editor.sidebarSettings": "Sidebar",
      "editor.exit": "Exit edit mode",
      "editor.undo": "Undo",
      "editor.redo": "Redo",
      "editor.addBlockHere": "Add block here",
      "editor.moveUp": "Move block up",
      "editor.moveDown": "Move block down",
      "editor.duplicate": "Duplicate block",
      "editor.delete": "Delete block",
      "editor.selectBlock": "Select",
      "editor.reorderBlock": "Reorder block: press and hold, then drag",
      "editor.blockDeleted": "Block deleted",
      "editor.outlineEmpty": "This page has no blocks yet.",
      "editor.noBlockSelected": "Tap a block on the page to edit it",
      "editor.resetTitle": "Reset everything?",
      "editor.resetMessage": "This discards every change and cannot be undone.",
      "editor.imageInstructions": "Add the file to public/images/, then reload to see it.",
      "editor.unsupportedBrowser": "Editing needs a newer mobile browser. Open this page on a computer, or update your browser to try it.",
      "editor.importParseError": "That file is not valid JSON. Nothing was changed.",
      "editor.importShapeError": "That JSON is not a site config — it needs meta, theme (colors, fonts, sizes), at least one page, i18n.es and sidebar. Nothing was changed.",
      "editor.storageError": "Could not write to browser storage — the config may be too large or storage is blocked. Nothing was changed.",
      "editor.pickBlock": "Add a block",
      "editor.close": "Close",
      "editor.categoryAll": "All",
      "editor.categoryText": "Text",
      "editor.categoryContent": "Content",
      "editor.categoryMedia": "Media",
      "editor.categoryLayout": "Layout",
      "editor.categoryInteractive": "Interactive",
      "editor.panelLabel": "Editor",
      "editor.expandCollapse": "Expand or collapse the editor",
      "custom.title_mm6xjra1": "SKILLS UNIPILOTO",
      "custom.subtitle_mm6xkn18": "Universidad Piloto de Colombia",
      "custom.description_mm6xl2h9": "Developed a full web application for user data collection, visualization and management, delivering a functional solution with an admin panel within one month.",
      "custom.role_mm6y0lbl": "Intern — Developer",
      "custom.company_mm6y2c7d": "Universidad Piloto de Colombia",
      "custom.description_mm6y3wp7": "Developed key game features including user options, menus, game mechanics, animations and code refactoring in Unity with C#.\nFixed inherited project bugs and conducted the first successful tests on mobile devices.\nAuthored technical reports and working papers documenting project progress.",
      "custom.company_mm6y5uzp": "Universidad Piloto de Colombia",
      "custom.description_mm6y6nbb": "Built a functional web application in one month featuring search, data management and visualization capabilities.\nImplemented an admin dashboard with role-based authentication for administrators and managers using HTML, CSS, React, Node.js, Express.js and MySQL.",
      "custom.role_mm6y6u3p": "Full Stack Web Developer"
    },
    "pt": {
      "seo.home.title": "Fernando Gonzalez Leon | Desenvolvedor de Software",
      "seo.home.description": "Engenheiro mecatrônico e desenvolvedor de software especializado em aplicações web, móveis e soluções com inteligência artificial.",
      "seo.portfolio.title": "Fernando Gonzalez Leon | Portfólio",
      "seo.portfolio.description": "Projetos em desenvolvimento de jogos educativos, aplicações web full stack e soluções móveis.",
      "seo.experience.title": "Fernando Gonzalez Leon | Experiência Profissional",
      "seo.experience.description": "Experiência em desenvolvimento de software, integração de IA e criação de jogos educativos.",
      "seo.aitools.title": "Fernando Gonzalez Leon | Ferramentas com IA",
      "seo.aitools.description": "Projetos e ferramentas desenvolvidos integrando inteligência artificial em fluxos de trabalho reais.",
      "seo.contact.title": "Fernando Gonzalez Leon | Contato",
      "seo.contact.description": "Entre em contato para oportunidades de trabalho, colaborações ou consultas profissionais.",
      "nav.home": "Início",
      "nav.portfolio": "Portfólio",
      "nav.experience": "Experiência",
      "nav.aitools": "AI Tools",
      "nav.contact": "Contato",
      "home.name": "Fernando Gonzalez Leon",
      "home.title": "Engenheiro Mecatrônico & Desenvolvedor de Software",
      "home.bio": "Desenvolvedor de software com formação em engenharia mecatrônica. Especializado em aplicações web, móveis e desktop com experiência em integração de IA, desenvolvimento de jogos e arquiteturas full stack.",
      "home.cta": "Ver Meu Trabalho",
      "portfolio.heading": "Portfólio",
      "demo.tryLive": "Experimente ao vivo",
      "demo.badge": "Demo · dados fictícios",
      "demo.reset": "Reiniciar",
      "demo.openNewTab": "Abrir em nova aba",
      "demo.close": "Fechar demo",
      "demo.loading": "Carregando demo…",
      "projects.pssman.title": "PSS_MAN",
      "projects.pssman.subtitle": "Gerenciador de senhas auto-hospedado",
      "projects.pssman.description": "Gerenciador de senhas multiusuário que projetei para rodar em um Raspberry Pi em casa, acessível pela rede local ou Tailscale. Cada cofre é criptografado com Argon2id e AES-GCM, o login suporta TOTP e dispositivos confiáveis, e os administradores gerenciam usuários e funções. Inclui gerador de senhas, backups criptografados com lembretes, inglês/espanhol, temas claro e escuro e uma extensão de preenchimento automático para Chrome. A demo ao vivo executa a interface real com dados fictícios no navegador.",
      "projects.azoni.title": "AZONI",
      "projects.azoni.subtitle": "Grupo de Pesquisa Open Creator — Universidad Piloto de Colombia",
      "projects.azoni.description": "Projetei e desenvolvi um FPS 3D educativo para dispositivos móveis focado no ensino de práticas de reciclagem. Implementei mecânicas de jogo, sistemas de níveis, UI/UX e otimização de desempenho usando Unity e C#.",
      "projects.azoni-terb.title": "AZONI TERB",
      "projects.azoni-terb.subtitle": "Projeto de Pesquisa T.E.R.B. — Universidad Piloto de Colombia",
      "projects.azoni-terb.description": "Desenvolvi um jogo educativo 2D para o projeto de pesquisa T.E.R.B., publicado com sucesso na Google Play Store e App Store. Implementei mecânicas de jogo, sistemas de níveis progressivos e conteúdo educativo interativo.",
      "projects.touch-the-box.title": "TOUCH THE BOX",
      "projects.touch-the-box.subtitle": "Publicado na Google Play Store",
      "projects.touch-the-box.description": "Jogo móvel de reflexos publicado independentemente na Google Play Store. Desenvolvi mecânicas de jogo completas, sistema de pontuação e design de interface usando Unity e C#.",
      "experience.heading": "Experiência",
      "experience.certHeading": "Certificações",
      "experience.item1.role": "Desenvolvedor Júnior",
      "experience.item1.company": "Dynamic Modular Systems (DMS)",
      "experience.item1.description": "Implementei sistemas com inteligência artificial usando técnicas de RAG, ferramentas de IA, MCP e APIs REST para integrar capacidades de IA em aplicações corporativas.\nDesenvolvi e implantei APIs escaláveis para sistemas de chat com contexto conversacional potencializados por IA.\nContribuí para a modernização da infraestrutura tecnológica da empresa através de soluções baseadas em IA.",
      "experience.item2.role": "Desenvolvedor Júnior de Jogos",
      "experience.item2.company": "Grupo de Pesquisa Open Creator — Universidad Piloto de Colombia",
      "experience.item2.description": "Alcancei a implantação bem-sucedida nas lojas de aplicativos móveis (Google Play e App Store) com zero relatórios de bugs críticos através de práticas de desenvolvimento orientado a testes.\nDesenvolvi mecânicas de jogo, interfaces de usuário, animações, níveis e formulários usando Unity, C# e Firebase.\nParticipei de reuniões diárias sob metodologia SCRUM, responsável por depuração de código, conceptualização de ideias e elaboração de relatórios técnicos mensais.",
      "experience.cert1.title": "Unity Android Game Development: Build 7 2D & 3D Games",
      "experience.cert1.issuer": "Udemy",
      "certificate.viewLink": "Ver Certificado",
      "notfound.title": "Página não encontrada",
      "aitools.heading": "Ferramentas com IA",
      "aitools.intro": "Projetos construídos integrando inteligência artificial no fluxo de desenvolvimento, demonstrando minha capacidade de adotar e aplicar tecnologias de IA em soluções reais.",
      "aitools.editToggle": "Editar Minha Página",
      "aitools.pomodoro.title": "Pomodoro Timer",
      "aitools.pomodoro.desc": "Temporizador de produtividade com ciclos de trabalho e descanso configuráveis. Projetado para otimizar sessões de foco com intervalos de 25 minutos de trabalho e 5 de descanso.",
      "aitools.meapp.title": "me_app — Personal Life Tracker",
      "aitools.meapp.desc": "Aplicativo móvel completo para rastreamento e gestão da vida pessoal. Desenvolvido com React Native e Firebase, com sincronização em tempo real e arquitetura offline-first.",
      "aitools.meapp.f1.title": "Clothing Tracker",
      "aitools.meapp.f1.desc": "Gestão de roupas com documentação fotográfica e estatísticas detalhadas de uso",
      "aitools.meapp.f2.title": "Workout Tracker",
      "aitools.meapp.f2.desc": "Mais de 40 exercícios integrados com modelos personalizáveis e rastreamento de sessões",
      "aitools.meapp.f3.title": "Real-time Sync",
      "aitools.meapp.f3.desc": "Sincronização multi-dispositivo em tempo real com Firebase",
      "aitools.meapp.f4.title": "Offline-first",
      "aitools.meapp.f4.desc": "Cache local com SQLite e sincronização automática na nuvem",
      "aitools.meapp.techLabel": "Tech Stack",
      "contact.heading": "Contato",
      "contact.subtitle": "Aberto a oportunidades de trabalho e colaborações. Vamos conectar.",
      "contact.download": "Baixar CV",
      "contact.linkedin": "LinkedIn",
      "contact.github": "GitHub",
      "contact.email": "Email",
      "editor.playgroundBanner": "Playground",
      "editor.adminBanner": "Modo Administrador",
      "editor.general": "Geral",
      "editor.block": "Bloco",
      "editor.outline": "Estrutura",
      "editor.colors": "Cores",
      "editor.fonts": "Fontes",
      "editor.images": "Imagens",
      "editor.headingFont": "Fonte dos Títulos",
      "editor.bodyFont": "Fonte do Texto",
      "editor.profilePhoto": "Foto de Perfil",
      "editor.layoutStyle": "Layout e Estilo",
      "editor.content": "Conteúdo",
      "editor.save": "Salvar",
      "editor.apply": "Aplicar",
      "editor.reset": "Reiniciar",
      "editor.cancel": "Cancelar",
      "editor.export": "Exportar",
      "editor.import": "Importar",
      "editor.sidebarSettings": "Barra Lateral",
      "editor.exit": "Sair do modo de edição",
      "editor.undo": "Desfazer",
      "editor.redo": "Refazer",
      "editor.addBlockHere": "Adicionar bloco aqui",
      "editor.moveUp": "Mover bloco para cima",
      "editor.moveDown": "Mover bloco para baixo",
      "editor.duplicate": "Duplicar bloco",
      "editor.delete": "Excluir bloco",
      "editor.selectBlock": "Selecionar",
      "editor.reorderBlock": "Reordenar bloco: mantenha pressionado e arraste",
      "editor.blockDeleted": "Bloco excluído",
      "editor.outlineEmpty": "Esta página ainda não tem blocos.",
      "editor.noBlockSelected": "Toque em um bloco na página para editá-lo",
      "editor.resetTitle": "Reiniciar tudo?",
      "editor.resetMessage": "Isso descarta todas as alterações e não pode ser desfeito.",
      "editor.imageInstructions": "Adicione o arquivo a public/images/ e recarregue a página para vê-lo.",
      "editor.unsupportedBrowser": "A edição requer um navegador móvel mais recente. Abra esta página em um computador ou atualize seu navegador para experimentá-la.",
      "editor.importParseError": "Esse arquivo não é um JSON válido. Nada foi alterado.",
      "editor.importShapeError": "Esse JSON não é uma configuração de site válida — precisa de meta, theme (colors, fonts, sizes), pelo menos uma página, i18n.es e sidebar. Nada foi alterado.",
      "editor.storageError": "Não foi possível gravar no armazenamento do navegador — a configuração pode ser grande demais ou o armazenamento está bloqueado. Nada foi alterado.",
      "editor.pickBlock": "Adicionar um bloco",
      "editor.close": "Fechar",
      "editor.categoryAll": "Todos",
      "editor.categoryText": "Texto",
      "editor.categoryContent": "Conteúdo",
      "editor.categoryMedia": "Mídia",
      "editor.categoryLayout": "Layout",
      "editor.categoryInteractive": "Interativo",
      "editor.panelLabel": "Editor",
      "editor.expandCollapse": "Expandir ou recolher o editor",
      "custom.title_mm6xjra1": "SKILLS UNIPILOTO",
      "custom.subtitle_mm6xkn18": "Universidad Piloto de Colombia",
      "custom.description_mm6xl2h9": "Desenvolvi um aplicativo web completo para coleta, visualização e gestão de dados de usuários, entregando uma solução funcional com painel administrativo em um mês.",
      "custom.role_mm6y0lbl": "Estagiário — Desenvolvedor",
      "custom.company_mm6y2c7d": "Universidad Piloto de Colombia",
      "custom.description_mm6y3wp7": "Desenvolvi funcionalidades-chave do jogo incluindo opções de usuário, menus, mecânicas, animações e refatoração de código em Unity com C#.\nCorregi bugs herdados do projeto e conduzi os primeiros testes bem-sucedidos em dispositivos móveis.\nElaborei relatórios técnicos e working papers documentando o progresso do projeto.",
      "custom.company_mm6y5uzp": "Universidad Piloto de Colombia",
      "custom.description_mm6y6nbb": "Construí um aplicativo web funcional em um mês com funcionalidades de busca, gestão e visualização de dados.\nImplementei um painel administrativo com autenticação baseada em papéis para administradores e gestores usando HTML, CSS, React, Node.js, Express.js e MySQL.",
      "custom.role_mm6y6u3p": "Desenvolvedor Web Full Stack"
    },
    "ja": {
      "seo.home.title": "Fernando Gonzalez Leon | ソフトウェア開発者",
      "seo.home.description": "Web・モバイルアプリケーションとAIソリューションを専門とするメカトロニクスエンジニア兼ソフトウェア開発者。",
      "seo.portfolio.title": "Fernando Gonzalez Leon | ポートフォリオ",
      "seo.portfolio.description": "教育ゲーム開発、フルスタックWebアプリケーション、モバイルソリューションの実績。",
      "seo.experience.title": "Fernando Gonzalez Leon | 職務経歴",
      "seo.experience.description": "ソフトウェア開発、AI統合、教育ゲーム開発の実務経験。",
      "seo.aitools.title": "Fernando Gonzalez Leon | AIツール",
      "seo.aitools.description": "実際のワークフローにAIを統合して構築したプロジェクトとツール。",
      "seo.contact.title": "Fernando Gonzalez Leon | お問い合わせ",
      "seo.contact.description": "お仕事のご依頼、コラボレーション、お問い合わせはこちらから。",
      "nav.home": "ホーム",
      "nav.portfolio": "ポートフォリオ",
      "nav.experience": "経歴",
      "nav.aitools": "AIツール",
      "nav.contact": "お問い合わせ",
      "home.name": "Fernando Gonzalez Leon",
      "home.title": "メカトロニクスエンジニア & ソフトウェア開発者",
      "home.bio": "メカトロニクス工学のバックグラウンドを持つソフトウェア開発者。Web・モバイル・デスクトップアプリケーションを専門とし、AI統合、ゲーム開発、フルスタックアーキテクチャの実務経験があります。",
      "home.cta": "実績を見る",
      "portfolio.heading": "ポートフォリオ",
      "demo.tryLive": "ライブで試す",
      "demo.badge": "デモ · 架空のデータ",
      "demo.reset": "リセット",
      "demo.openNewTab": "新しいタブで開く",
      "demo.close": "デモを閉じる",
      "demo.loading": "デモを読み込み中…",
      "projects.pssman.title": "PSS_MAN",
      "projects.pssman.subtitle": "セルフホスト型パスワードマネージャー",
      "projects.pssman.description": "自宅の Raspberry Pi で動作し、LAN または Tailscale 経由で利用するよう設計したマルチユーザー対応のパスワードマネージャーです。各保管庫は Argon2id と AES-GCM で暗号化され、ログインは TOTP と信頼済みデバイスに対応し、管理者はユーザーとロールを管理できます。パスワード生成、リマインダー付きの暗号化バックアップ、英語/スペイン語、ライト/ダークテーマ、Chrome 自動入力拡張機能を備えています。ライブデモでは、実際の画面をブラウザ内の架空データで動かしています。",
      "projects.azoni.title": "AZONI",
      "projects.azoni.subtitle": "Open Creator研究グループ — コロンビア・パイロット大学",
      "projects.azoni.description": "リサイクル教育を目的としたモバイル向け3D教育FPSを設計・開発。UnityとC#を使用してゲームメカニクス、レベルシステム、UI/UX、パフォーマンス最適化を実装。",
      "projects.azoni-terb.title": "AZONI TERB",
      "projects.azoni-terb.subtitle": "T.E.R.B.研究プロジェクト — コロンビア・パイロット大学",
      "projects.azoni-terb.description": "T.E.R.B.研究プロジェクトの2D教育ゲームを開発し、Google PlayストアとApp Storeに公開。ゲームメカニクス、段階的レベルシステム、インタラクティブな教育コンテンツを実装。",
      "projects.touch-the-box.title": "TOUCH THE BOX",
      "projects.touch-the-box.subtitle": "Google Play Storeで公開中",
      "projects.touch-the-box.description": "Google Play Storeに独立して公開した反射神経モバイルゲーム。UnityとC#を使用して完全なゲームメカニクス、スコアリングシステム、インターフェースデザインを開発。",
      "experience.heading": "職務経歴",
      "experience.certHeading": "資格・認定",
      "experience.item1.role": "ジュニア開発者",
      "experience.item1.company": "Dynamic Modular Systems (DMS)",
      "experience.item1.description": "RAG技術、AIツール、MCP、REST APIを活用してAI機能を企業アプリケーションに統合するシステムを実装。\nAI駆動の会話コンテキスト付きチャットシステム向けスケーラブルAPIを開発・デプロイ。\nAIソリューションを通じて企業の技術インフラの近代化に貢献。",
      "experience.item2.role": "ジュニアゲーム開発者",
      "experience.item2.company": "Open Creator研究グループ — コロンビア・パイロット大学",
      "experience.item2.description": "テスト駆動開発により、クリティカルなバグ報告ゼロでモバイルアプリストア（Google PlayとApp Store）への公開を達成。\nUnity、C#、Firebaseを使用してゲームメカニクス、UI、アニメーション、レベル、フォームを開発。\nSCRUM方法論によるデイリースタンドアップに参加し、コードデバッグ、アイデア立案、月次技術報告書の作成を担当。",
      "experience.cert1.title": "Unity Android Game Development: Build 7 2D & 3D Games",
      "experience.cert1.issuer": "Udemy",
      "certificate.viewLink": "証明書を見る",
      "notfound.title": "ページが見つかりません",
      "aitools.heading": "AIツール",
      "aitools.intro": "開発ワークフローにAIを統合して構築したプロジェクト。AI技術を実際のソリューションに採用・適用する能力を示しています。",
      "aitools.editToggle": "ページを編集",
      "aitools.pomodoro.title": "ポモドーロタイマー",
      "aitools.pomodoro.desc": "作業と休憩の設定可能なサイクルを持つ生産性タイマー。25分の作業と5分の休憩で集中セッションを最適化。",
      "aitools.meapp.title": "me_app — パーソナルライフトラッカー",
      "aitools.meapp.desc": "個人の生活管理・追跡のための総合モバイルアプリ。React NativeとFirebaseで構築し、リアルタイム同期とオフラインファースト設計を採用。",
      "aitools.meapp.f1.title": "Clothing Tracker",
      "aitools.meapp.f1.desc": "写真記録と詳細な使用統計による衣類管理",
      "aitools.meapp.f2.title": "Workout Tracker",
      "aitools.meapp.f2.desc": "40以上のエクササイズとカスタマイズ可能なテンプレート、セッション追跡",
      "aitools.meapp.f3.title": "Real-time Sync",
      "aitools.meapp.f3.desc": "Firebaseによるマルチデバイスリアルタイム同期",
      "aitools.meapp.f4.title": "Offline-first",
      "aitools.meapp.f4.desc": "SQLiteローカルキャッシュと接続時自動クラウド同期",
      "aitools.meapp.techLabel": "Tech Stack",
      "contact.heading": "お問い合わせ",
      "contact.subtitle": "お仕事のご依頼やコラボレーションのご相談をお待ちしています。",
      "contact.download": "履歴書をダウンロード",
      "contact.linkedin": "LinkedIn",
      "contact.github": "GitHub",
      "contact.email": "メール",
      "editor.playgroundBanner": "プレイグラウンド",
      "editor.adminBanner": "管理者モード",
      "editor.general": "一般",
      "editor.block": "ブロック",
      "editor.outline": "アウトライン",
      "editor.colors": "カラー",
      "editor.fonts": "フォント",
      "editor.images": "画像",
      "editor.headingFont": "見出しフォント",
      "editor.bodyFont": "本文フォント",
      "editor.profilePhoto": "プロフィール写真",
      "editor.layoutStyle": "レイアウトとスタイル",
      "editor.content": "コンテンツ",
      "editor.save": "保存",
      "editor.apply": "適用",
      "editor.reset": "リセット",
      "editor.cancel": "キャンセル",
      "editor.export": "エクスポート",
      "editor.import": "インポート",
      "editor.sidebarSettings": "サイドバー",
      "editor.exit": "編集モードを終了",
      "editor.undo": "元に戻す",
      "editor.redo": "やり直す",
      "editor.addBlockHere": "ここにブロックを追加",
      "editor.moveUp": "ブロックを上に移動",
      "editor.moveDown": "ブロックを下に移動",
      "editor.duplicate": "ブロックを複製",
      "editor.delete": "ブロックを削除",
      "editor.selectBlock": "選択",
      "editor.reorderBlock": "ブロックを並べ替え: 長押ししてドラッグ",
      "editor.blockDeleted": "ブロックを削除しました",
      "editor.outlineEmpty": "このページにはまだブロックがありません。",
      "editor.noBlockSelected": "ページ上のブロックをタップして編集",
      "editor.resetTitle": "すべてリセットしますか?",
      "editor.resetMessage": "すべての変更が破棄され、元に戻すことはできません。",
      "editor.imageInstructions": "ファイルを public/images/ に追加し、再読み込みすると表示されます。",
      "editor.unsupportedBrowser": "編集には最新のモバイルブラウザが必要です。パソコンでこのページを開くか、ブラウザを更新してお試しください。",
      "editor.importParseError": "そのファイルは有効なJSONではありません。変更は行われませんでした。",
      "editor.importShapeError": "そのJSONはサイト設定ではありません — meta、theme（colors、fonts、sizes）、少なくとも1つのページ、i18n.es、sidebar が必要です。変更は行われませんでした。",
      "editor.storageError": "ブラウザのストレージに書き込めませんでした — 設定が大きすぎるか、ストレージがブロックされている可能性があります。変更は行われませんでした。",
      "editor.pickBlock": "ブロックを追加",
      "editor.close": "閉じる",
      "editor.categoryAll": "すべて",
      "editor.categoryText": "テキスト",
      "editor.categoryContent": "コンテンツ",
      "editor.categoryMedia": "メディア",
      "editor.categoryLayout": "レイアウト",
      "editor.categoryInteractive": "インタラクティブ",
      "editor.panelLabel": "エディタ",
      "editor.expandCollapse": "エディタを展開または折りたたむ",
      "custom.title_mm6xjra1": "SKILLS UNIPILOTO",
      "custom.subtitle_mm6xkn18": "コロンビア・パイロット大学",
      "custom.description_mm6xl2h9": "ユーザーデータの収集・可視化・管理のためのWebアプリケーションを開発し、管理パネル付きの機能的なソリューションを1ヶ月で納品。",
      "custom.role_mm6y0lbl": "インターン — 開発者",
      "custom.company_mm6y2c7d": "コロンビア・パイロット大学",
      "custom.description_mm6y3wp7": "UnityとC#でユーザーオプション、メニュー、ゲームメカニクス、アニメーション、コードリファクタリングなどの主要なゲーム機能を開発。\nプロジェクトから引き継いだバグを修正し、モバイルデバイスでの初の成功テストを実施。\nプロジェクトの進捗を文書化する技術報告書とワーキングペーパーを作成。",
      "custom.company_mm6y5uzp": "コロンビア・パイロット大学",
      "custom.description_mm6y6nbb": "検索・データ管理・可視化機能を備えた機能的なWebアプリケーションを1ヶ月で構築。\nHTML、CSS、React、Node.js、Express.js、MySQLを使用して、管理者・マネージャー向けのロールベース認証付き管理ダッシュボードを実装。",
      "custom.role_mm6y6u3p": "フルスタックWeb開発者"
    },
    "ko": {
      "seo.home.title": "Fernando Gonzalez Leon | 소프트웨어 개발자",
      "seo.home.description": "웹, 모바일 애플리케이션 및 AI 솔루션을 전문으로 하는 메카트로닉스 엔지니어 겸 소프트웨어 개발자.",
      "seo.portfolio.title": "Fernando Gonzalez Leon | 포트폴리오",
      "seo.portfolio.description": "교육용 게임 개발, 풀스택 웹 애플리케이션 및 모바일 솔루션 프로젝트.",
      "seo.experience.title": "Fernando Gonzalez Leon | 경력",
      "seo.experience.description": "소프트웨어 개발, AI 통합 및 교육용 게임 개발 경력.",
      "seo.aitools.title": "Fernando Gonzalez Leon | AI 도구",
      "seo.aitools.description": "실제 워크플로우에 인공지능을 통합하여 구축한 프로젝트와 도구.",
      "seo.contact.title": "Fernando Gonzalez Leon | 연락처",
      "seo.contact.description": "채용 기회, 협업 또는 전문 문의를 위해 연락해 주세요.",
      "nav.home": "홈",
      "nav.portfolio": "포트폴리오",
      "nav.experience": "경력",
      "nav.aitools": "AI 도구",
      "nav.contact": "연락처",
      "home.name": "Fernando Gonzalez Leon",
      "home.title": "메카트로닉스 엔지니어 & 소프트웨어 개발자",
      "home.bio": "메카트로닉스 공학 배경의 소프트웨어 개발자. 웹, 모바일 및 데스크톱 애플리케이션을 전문으로 하며 AI 통합, 게임 개발, 풀스택 아키텍처에 대한 실무 경험을 보유하고 있습니다.",
      "home.cta": "작업물 보기",
      "portfolio.heading": "포트폴리오",
      "demo.tryLive": "라이브로 체험하기",
      "demo.badge": "데모 · 가상 데이터",
      "demo.reset": "초기화",
      "demo.openNewTab": "새 탭에서 열기",
      "demo.close": "데모 닫기",
      "demo.loading": "데모 불러오는 중…",
      "projects.pssman.title": "PSS_MAN",
      "projects.pssman.subtitle": "셀프 호스팅 비밀번호 관리자",
      "projects.pssman.description": "집에 있는 Raspberry Pi에서 실행되고 LAN 또는 Tailscale로 접속하도록 설계한 다중 사용자 비밀번호 관리자입니다. 각 보관함은 Argon2id와 AES-GCM으로 암호화되며, 로그인은 TOTP와 신뢰할 수 있는 기기를 지원하고, 관리자는 사용자와 역할을 관리합니다. 비밀번호 생성기, 알림이 있는 암호화 백업, 영어/스페인어, 라이트·다크 테마, Chrome 자동 완성 확장 프로그램을 포함합니다. 라이브 데모는 실제 인터페이스를 브라우저 안의 가상 데이터로 실행합니다.",
      "projects.azoni.title": "AZONI",
      "projects.azoni.subtitle": "Open Creator 연구 그룹 — 콜롬비아 파일럿 대학교",
      "projects.azoni.description": "재활용 교육을 목적으로 한 모바일용 3D 교육 FPS를 설계하고 개발. Unity와 C#을 사용하여 게임 메카닉, 레벨 시스템, UI/UX 및 성능 최적화를 구현.",
      "projects.azoni-terb.title": "AZONI TERB",
      "projects.azoni-terb.subtitle": "T.E.R.B. 연구 프로젝트 — 콜롬비아 파일럿 대학교",
      "projects.azoni-terb.description": "T.E.R.B. 연구 프로젝트를 위한 2D 교육 게임을 개발하여 Google Play 스토어와 App Store에 성공적으로 출시. 게임 메카닉, 단계적 레벨 시스템 및 인터랙티브 교육 콘텐츠를 구현.",
      "projects.touch-the-box.title": "TOUCH THE BOX",
      "projects.touch-the-box.subtitle": "Google Play 스토어 출시",
      "projects.touch-the-box.description": "Google Play 스토어에 독립적으로 출시한 반사 신경 모바일 게임. Unity와 C#을 사용하여 전체 게임 메카닉, 점수 시스템 및 인터페이스 디자인을 개발.",
      "experience.heading": "경력",
      "experience.certHeading": "자격증",
      "experience.item1.role": "주니어 개발자",
      "experience.item1.company": "Dynamic Modular Systems (DMS)",
      "experience.item1.description": "RAG 기술, AI 도구, MCP 및 REST API를 활용하여 기업 애플리케이션에 AI 기능을 통합하는 시스템을 구현.\nAI 기반 대화 컨텍스트를 갖춘 채팅 시스템용 확장 가능한 API를 개발 및 배포.\nAI 기반 솔루션을 통해 기업의 기술 인프라 현대화에 기여.",
      "experience.item2.role": "주니어 게임 개발자",
      "experience.item2.company": "Open Creator 연구 그룹 — 콜롬비아 파일럿 대학교",
      "experience.item2.description": "테스트 주도 개발을 통해 치명적 버그 보고 제로로 모바일 앱 스토어(Google Play 및 App Store)에 성공적으로 배포.\nUnity, C#, Firebase를 사용하여 게임 메카닉, UI, 애니메이션, 레벨, 폼을 개발.\nSCRUM 방법론에 따른 데일리 스탠드업에 참여하며 코드 디버깅, 아이디어 구상, 월간 기술 보고서 작성을 담당.",
      "experience.cert1.title": "Unity Android Game Development: Build 7 2D & 3D Games",
      "experience.cert1.issuer": "Udemy",
      "certificate.viewLink": "인증서 보기",
      "notfound.title": "페이지를 찾을 수 없습니다",
      "aitools.heading": "AI 도구",
      "aitools.intro": "개발 워크플로우에 AI를 통합하여 구축한 프로젝트. 실제 솔루션에 AI 기술을 채택하고 적용하는 능력을 보여줍니다.",
      "aitools.editToggle": "페이지 편집",
      "aitools.pomodoro.title": "포모도로 타이머",
      "aitools.pomodoro.desc": "작업과 휴식의 설정 가능한 사이클을 갖춘 생산성 타이머. 25분 작업과 5분 휴식 간격으로 집중 세션을 최적화.",
      "aitools.meapp.title": "me_app — 개인 생활 트래커",
      "aitools.meapp.desc": "개인 생활 추적 및 관리를 위한 종합 모바일 앱. React Native와 Firebase로 구축하며 실시간 동기화 및 오프라인 퍼스트 아키텍처를 적용.",
      "aitools.meapp.f1.title": "Clothing Tracker",
      "aitools.meapp.f1.desc": "사진 기록과 상세 사용 통계를 통한 의류 관리",
      "aitools.meapp.f2.title": "Workout Tracker",
      "aitools.meapp.f2.desc": "40개 이상의 운동과 맞춤형 템플릿, 세션 추적",
      "aitools.meapp.f3.title": "Real-time Sync",
      "aitools.meapp.f3.desc": "Firebase를 통한 멀티 디바이스 실시간 동기화",
      "aitools.meapp.f4.title": "Offline-first",
      "aitools.meapp.f4.desc": "SQLite 로컬 캐시 및 연결 시 자동 클라우드 동기화",
      "aitools.meapp.techLabel": "Tech Stack",
      "contact.heading": "연락처",
      "contact.subtitle": "채용 기회와 협업에 열려 있습니다. 연락해 주세요.",
      "contact.download": "이력서 다운로드",
      "contact.linkedin": "LinkedIn",
      "contact.github": "GitHub",
      "contact.email": "이메일",
      "editor.playgroundBanner": "플레이그라운드",
      "editor.adminBanner": "관리자 모드",
      "editor.general": "일반",
      "editor.block": "블록",
      "editor.outline": "개요",
      "editor.colors": "색상",
      "editor.fonts": "글꼴",
      "editor.images": "이미지",
      "editor.headingFont": "제목 글꼴",
      "editor.bodyFont": "본문 글꼴",
      "editor.profilePhoto": "프로필 사진",
      "editor.layoutStyle": "레이아웃 및 스타일",
      "editor.content": "콘텐츠",
      "editor.save": "저장",
      "editor.apply": "적용",
      "editor.reset": "초기화",
      "editor.cancel": "취소",
      "editor.export": "내보내기",
      "editor.import": "가져오기",
      "editor.sidebarSettings": "사이드바",
      "editor.exit": "편집 모드 종료",
      "editor.undo": "실행 취소",
      "editor.redo": "다시 실행",
      "editor.addBlockHere": "여기에 블록 추가",
      "editor.moveUp": "블록 위로 이동",
      "editor.moveDown": "블록 아래로 이동",
      "editor.duplicate": "블록 복제",
      "editor.delete": "블록 삭제",
      "editor.selectBlock": "선택",
      "editor.reorderBlock": "블록 순서 변경: 길게 눌러 드래그",
      "editor.blockDeleted": "블록이 삭제되었습니다",
      "editor.outlineEmpty": "이 페이지에는 아직 블록이 없습니다.",
      "editor.noBlockSelected": "페이지에서 블록을 탭하여 편집하세요",
      "editor.resetTitle": "모두 초기화하시겠습니까?",
      "editor.resetMessage": "모든 변경 사항이 취소되며 되돌릴 수 없습니다.",
      "editor.imageInstructions": "파일을 public/images/ 에 추가한 후 새로고침하면 표시됩니다.",
      "editor.unsupportedBrowser": "편집하려면 최신 모바일 브라우저가 필요합니다. 컴퓨터에서 이 페이지를 열거나 브라우저를 업데이트한 후 시도해 보세요.",
      "editor.importParseError": "해당 파일은 유효한 JSON이 아닙니다. 아무것도 변경되지 않았습니다.",
      "editor.importShapeError": "해당 JSON은 사이트 설정이 아닙니다 — meta, theme(colors, fonts, sizes), 최소 하나의 페이지, i18n.es, sidebar가 필요합니다. 아무것도 변경되지 않았습니다.",
      "editor.storageError": "브라우저 저장소에 쓸 수 없습니다 — 설정이 너무 크거나 저장소가 차단되었을 수 있습니다. 아무것도 변경되지 않았습니다.",
      "editor.pickBlock": "블록 추가",
      "editor.close": "닫기",
      "editor.categoryAll": "전체",
      "editor.categoryText": "텍스트",
      "editor.categoryContent": "콘텐츠",
      "editor.categoryMedia": "미디어",
      "editor.categoryLayout": "레이아웃",
      "editor.categoryInteractive": "인터랙티브",
      "editor.panelLabel": "에디터",
      "editor.expandCollapse": "에디터 펼치기/접기",
      "custom.title_mm6xjra1": "SKILLS UNIPILOTO",
      "custom.subtitle_mm6xkn18": "콜롬비아 파일럿 대학교",
      "custom.description_mm6xl2h9": "사용자 데이터 수집, 시각화 및 관리를 위한 웹 애플리케이션을 개발하여 관리자 패널이 포함된 기능적 솔루션을 한 달 만에 납품.",
      "custom.role_mm6y0lbl": "인턴 — 개발자",
      "custom.company_mm6y2c7d": "콜롬비아 파일럿 대학교",
      "custom.description_mm6y3wp7": "Unity와 C#을 사용하여 사용자 옵션, 메뉴, 게임 메카닉, 애니메이션, 코드 리팩토링 등 핵심 게임 기능을 개발.\n프로젝트에서 상속된 버그를 수정하고 모바일 기기에서의 첫 성공적인 테스트를 수행.\n프로젝트 진행 상황을 문서화하는 기술 보고서와 워킹 페이퍼를 작성.",
      "custom.company_mm6y5uzp": "콜롬비아 파일럿 대학교",
      "custom.description_mm6y6nbb": "검색, 데이터 관리 및 시각화 기능을 갖춘 기능적 웹 애플리케이션을 한 달 만에 구축.\nHTML, CSS, React, Node.js, Express.js, MySQL을 사용하여 관리자 및 매니저를 위한 역할 기반 인증이 포함된 관리 대시보드를 구현.",
      "custom.role_mm6y6u3p": "풀스택 웹 개발자"
    },
    "zh": {
      "seo.home.title": "Fernando Gonzalez Leon | 软件开发者",
      "seo.home.description": "专注于Web、移动应用和AI解决方案的机电一体化工程师兼软件开发者。",
      "seo.portfolio.title": "Fernando Gonzalez Leon | 作品集",
      "seo.portfolio.description": "教育游戏开发、全栈Web应用和移动解决方案项目展示。",
      "seo.experience.title": "Fernando Gonzalez Leon | 工作经历",
      "seo.experience.description": "软件开发、AI集成和教育游戏开发的专业经验。",
      "seo.aitools.title": "Fernando Gonzalez Leon | AI工具",
      "seo.aitools.description": "将人工智能集成到实际工作流程中构建的项目和工具。",
      "seo.contact.title": "Fernando Gonzalez Leon | 联系方式",
      "seo.contact.description": "如有工作机会、合作意向或专业咨询，欢迎联系。",
      "nav.home": "首页",
      "nav.portfolio": "作品集",
      "nav.experience": "工作经历",
      "nav.aitools": "AI工具",
      "nav.contact": "联系方式",
      "home.name": "Fernando Gonzalez Leon",
      "home.title": "机电一体化工程师 & 软件开发者",
      "home.bio": "具有机电一体化工程背景的软件开发者。专注于Web、移动和桌面应用开发，拥有AI集成、游戏开发和全栈架构的实践经验。",
      "home.cta": "查看我的作品",
      "portfolio.heading": "作品集",
      "demo.tryLive": "在线试用",
      "demo.badge": "演示 · 虚构数据",
      "demo.reset": "重置",
      "demo.openNewTab": "在新标签页中打开",
      "demo.close": "关闭演示",
      "demo.loading": "正在加载演示…",
      "projects.pssman.title": "PSS_MAN",
      "projects.pssman.subtitle": "自托管密码管理器",
      "projects.pssman.description": "一款多用户密码管理器，我将其设计为在家中的树莓派上运行，可通过局域网或 Tailscale 访问。每个密码库都使用 Argon2id 和 AES-GCM 加密，登录支持 TOTP 和受信任设备，管理员可以管理用户和角色。它包含密码生成器、带提醒的加密备份、英语/西班牙语界面、浅色和深色主题，以及 Chrome 自动填充扩展。在线演示在浏览器中使用虚构数据运行真实界面。",
      "projects.azoni.title": "AZONI",
      "projects.azoni.subtitle": "Open Creator研究小组 — 哥伦比亚领航大学",
      "projects.azoni.description": "设计并开发了一款面向移动设备的3D教育FPS游戏，旨在教授回收实践。使用Unity和C#实现了游戏机制、关卡系统、UI/UX和性能优化。",
      "projects.azoni-terb.title": "AZONI TERB",
      "projects.azoni-terb.subtitle": "T.E.R.B.研究项目 — 哥伦比亚领航大学",
      "projects.azoni-terb.description": "为T.E.R.B.研究项目开发了2D教育游戏，成功发布于Google Play商店和App Store。实现了游戏机制、渐进式关卡系统和互动教育内容。",
      "projects.touch-the-box.title": "TOUCH THE BOX",
      "projects.touch-the-box.subtitle": "已发布于Google Play商店",
      "projects.touch-the-box.description": "独立发布于Google Play商店的反应力移动游戏。使用Unity和C#开发了完整的游戏机制、计分系统和界面设计。",
      "experience.heading": "工作经历",
      "experience.certHeading": "资质认证",
      "experience.item1.role": "初级开发者",
      "experience.item1.company": "Dynamic Modular Systems (DMS)",
      "experience.item1.description": "使用RAG技术、AI工具、MCP和REST API实现AI系统，将AI能力集成到企业应用中。\n开发并部署了具有对话上下文的AI驱动聊天系统的可扩展API。\n通过AI驱动的解决方案助力公司技术基础设施现代化。",
      "experience.item2.role": "初级游戏开发者",
      "experience.item2.company": "Open Creator研究小组 — 哥伦比亚领航大学",
      "experience.item2.description": "通过测试驱动开发实践，以零关键Bug报告成功发布至移动应用商店（Google Play和App Store）。\n使用Unity、C#和Firebase开发了游戏机制、用户界面、动画、关卡和表单。\n参与SCRUM方法论下的每日站会，负责代码调试、创意构思和月度技术报告撰写。",
      "experience.cert1.title": "Unity Android Game Development: Build 7 2D & 3D Games",
      "experience.cert1.issuer": "Udemy",
      "certificate.viewLink": "查看证书",
      "notfound.title": "页面未找到",
      "aitools.heading": "AI工具",
      "aitools.intro": "将AI集成到开发工作流程中构建的项目，展示了我在实际解决方案中采用和应用AI技术的能力。",
      "aitools.editToggle": "编辑页面",
      "aitools.pomodoro.title": "番茄钟",
      "aitools.pomodoro.desc": "可配置工作和休息周期的生产力计时器。以25分钟工作和5分钟休息的间隔优化专注时段。",
      "aitools.meapp.title": "me_app — 个人生活追踪器",
      "aitools.meapp.desc": "全面的个人生活追踪和管理移动应用。使用React Native和Firebase构建，具有实时同步和离线优先架构。",
      "aitools.meapp.f1.title": "服装追踪",
      "aitools.meapp.f1.desc": "通过照片记录和详细使用统计管理衣物",
      "aitools.meapp.f2.title": "健身追踪",
      "aitools.meapp.f2.desc": "40多种内置锻炼项目，可自定义模板和会话追踪",
      "aitools.meapp.f3.title": "实时同步",
      "aitools.meapp.f3.desc": "通过Firebase实现多设备实时同步",
      "aitools.meapp.f4.title": "离线优先",
      "aitools.meapp.f4.desc": "SQLite本地缓存，连接时自动云同步",
      "aitools.meapp.techLabel": "技术栈",
      "contact.heading": "联系方式",
      "contact.subtitle": "期待工作机会和合作。欢迎联系。",
      "contact.download": "下载简历",
      "contact.linkedin": "LinkedIn",
      "contact.github": "GitHub",
      "contact.email": "邮箱",
      "editor.playgroundBanner": "演练场",
      "editor.adminBanner": "管理员模式",
      "editor.general": "常规",
      "editor.block": "模块",
      "editor.outline": "大纲",
      "editor.colors": "颜色",
      "editor.fonts": "字体",
      "editor.images": "图片",
      "editor.headingFont": "标题字体",
      "editor.bodyFont": "正文字体",
      "editor.profilePhoto": "头像",
      "editor.layoutStyle": "布局与样式",
      "editor.content": "内容",
      "editor.save": "保存",
      "editor.apply": "应用",
      "editor.reset": "重置",
      "editor.cancel": "取消",
      "editor.export": "导出",
      "editor.import": "导入",
      "editor.sidebarSettings": "侧边栏",
      "editor.exit": "退出编辑模式",
      "editor.undo": "撤销",
      "editor.redo": "重做",
      "editor.addBlockHere": "在此处添加模块",
      "editor.moveUp": "上移模块",
      "editor.moveDown": "下移模块",
      "editor.duplicate": "复制模块",
      "editor.delete": "删除模块",
      "editor.selectBlock": "选择",
      "editor.reorderBlock": "调整模块顺序：长按后拖动",
      "editor.blockDeleted": "模块已删除",
      "editor.outlineEmpty": "此页面还没有任何模块。",
      "editor.noBlockSelected": "点按页面上的模块进行编辑",
      "editor.resetTitle": "重置所有内容?",
      "editor.resetMessage": "这将放弃所有更改且无法撤销。",
      "editor.imageInstructions": "将文件添加到 public/images/,然后重新加载页面即可查看。",
      "editor.unsupportedBrowser": "编辑功能需要较新版本的移动浏览器。请在电脑上打开此页面,或更新浏览器后重试。",
      "editor.importParseError": "该文件不是有效的 JSON。未做任何更改。",
      "editor.importShapeError": "该 JSON 不是站点配置 — 需要 meta、theme（colors、fonts、sizes）、至少一个页面、i18n.es 和 sidebar。未做任何更改。",
      "editor.storageError": "无法写入浏览器存储 — 配置可能过大,或存储已被阻止。未做任何更改。",
      "editor.pickBlock": "添加模块",
      "editor.close": "关闭",
      "editor.categoryAll": "全部",
      "editor.categoryText": "文本",
      "editor.categoryContent": "内容",
      "editor.categoryMedia": "媒体",
      "editor.categoryLayout": "布局",
      "editor.categoryInteractive": "交互",
      "editor.panelLabel": "编辑器",
      "editor.expandCollapse": "展开或折叠编辑器",
      "custom.title_mm6xjra1": "SKILLS UNIPILOTO",
      "custom.subtitle_mm6xkn18": "哥伦比亚领航大学",
      "custom.description_mm6xl2h9": "开发了用于用户数据收集、可视化和管理的完整Web应用程序，在一个月内交付了带有管理面板的功能性解决方案。",
      "custom.role_mm6y0lbl": "实习生 — 开发者",
      "custom.company_mm6y2c7d": "哥伦比亚领航大学",
      "custom.description_mm6y3wp7": "使用Unity和C#开发了用户选项、菜单、游戏机制、动画和代码重构等关键游戏功能。\n修复了项目遗留Bug，并在移动设备上完成了首次成功测试。\n编写了记录项目进展的技术报告和工作论文。",
      "custom.company_mm6y5uzp": "哥伦比亚领航大学",
      "custom.description_mm6y6nbb": "在一个月内构建了具有搜索、数据管理和可视化功能的Web应用程序。\n使用HTML、CSS、React、Node.js、Express.js和MySQL实现了基于角色认证的管理仪表板。",
      "custom.role_mm6y6u3p": "全栈Web开发者"
    },
    "ru": {
      "seo.home.title": "Fernando Gonzalez Leon | Разработчик ПО",
      "seo.home.description": "Инженер-мехатроник и разработчик ПО, специализирующийся на веб-, мобильных приложениях и решениях с ИИ.",
      "seo.portfolio.title": "Fernando Gonzalez Leon | Портфолио",
      "seo.portfolio.description": "Проекты в области разработки образовательных игр, full stack веб-приложений и мобильных решений.",
      "seo.experience.title": "Fernando Gonzalez Leon | Опыт работы",
      "seo.experience.description": "Опыт в разработке ПО, интеграции ИИ и создании образовательных игр.",
      "seo.aitools.title": "Fernando Gonzalez Leon | Инструменты ИИ",
      "seo.aitools.description": "Проекты и инструменты, созданные с интеграцией искусственного интеллекта в реальные рабочие процессы.",
      "seo.contact.title": "Fernando Gonzalez Leon | Контакты",
      "seo.contact.description": "Свяжитесь со мной для обсуждения вакансий, сотрудничества или профессиональных вопросов.",
      "nav.home": "Главная",
      "nav.portfolio": "Портфолио",
      "nav.experience": "Опыт",
      "nav.aitools": "ИИ-инструменты",
      "nav.contact": "Контакты",
      "home.name": "Fernando Gonzalez Leon",
      "home.title": "Инженер-мехатроник и разработчик ПО",
      "home.bio": "Разработчик ПО с образованием в области мехатроники. Специализируюсь на веб-, мобильных и десктопных приложениях с практическим опытом интеграции ИИ, разработки игр и full stack архитектур.",
      "home.cta": "Смотреть работы",
      "portfolio.heading": "Портфолио",
      "demo.tryLive": "Попробовать вживую",
      "demo.badge": "Демо · вымышленные данные",
      "demo.reset": "Сбросить",
      "demo.openNewTab": "Открыть в новой вкладке",
      "demo.close": "Закрыть демо",
      "demo.loading": "Загрузка демо…",
      "projects.pssman.title": "PSS_MAN",
      "projects.pssman.subtitle": "Самостоятельно размещаемый менеджер паролей",
      "projects.pssman.description": "Многопользовательский менеджер паролей, который я спроектировал для работы на Raspberry Pi дома с доступом по локальной сети или через Tailscale. Каждое хранилище шифруется с помощью Argon2id и AES-GCM, вход поддерживает TOTP и доверенные устройства, а администраторы управляют пользователями и ролями. Есть генератор паролей, зашифрованные резервные копии с напоминаниями, английский и испанский языки, светлая и тёмная темы и расширение автозаполнения для Chrome. Живое демо запускает настоящий интерфейс на вымышленных данных прямо в браузере.",
      "projects.azoni.title": "AZONI",
      "projects.azoni.subtitle": "Исследовательская группа Open Creator — Университет Пилото де Колумбия",
      "projects.azoni.description": "Спроектировал и разработал образовательный 3D FPS для мобильных устройств, направленный на обучение практикам переработки. Реализовал игровую механику, систему уровней, UI/UX и оптимизацию производительности на Unity и C#.",
      "projects.azoni-terb.title": "AZONI TERB",
      "projects.azoni-terb.subtitle": "Исследовательский проект T.E.R.B. — Университет Пилото де Колумбия",
      "projects.azoni-terb.description": "Разработал 2D образовательную игру для исследовательского проекта T.E.R.B., успешно опубликованную в Google Play Store и App Store. Реализовал игровую механику, прогрессивную систему уровней и интерактивный образовательный контент.",
      "projects.touch-the-box.title": "TOUCH THE BOX",
      "projects.touch-the-box.subtitle": "Опубликовано в Google Play Store",
      "projects.touch-the-box.description": "Самостоятельно опубликованная мобильная игра на реакцию в Google Play Store. Разработал полную игровую механику, систему подсчёта очков и дизайн интерфейса на Unity и C#.",
      "experience.heading": "Опыт работы",
      "experience.certHeading": "Сертификаты",
      "experience.item1.role": "Младший разработчик",
      "experience.item1.company": "Dynamic Modular Systems (DMS)",
      "experience.item1.description": "Реализовал системы ИИ с использованием техник RAG, AI-инструментов, MCP и REST API для интеграции возможностей ИИ в корпоративные приложения.\nРазработал и развернул масштабируемые API для чат-систем с диалоговым контекстом на основе ИИ.\nСпособствовал модернизации технологической инфраструктуры компании через решения на базе ИИ.",
      "experience.item2.role": "Младший разработчик игр",
      "experience.item2.company": "Исследовательская группа Open Creator — Университет Пилото де Колумбия",
      "experience.item2.description": "Обеспечил успешную публикацию в мобильных магазинах приложений (Google Play и App Store) с нулевым количеством критических багов благодаря практикам разработки через тестирование.\nРазработал игровую механику, пользовательские интерфейсы, анимации, уровни и формы на Unity, C# и Firebase.\nУчаствовал в ежедневных стендапах по методологии SCRUM, отвечал за отладку кода, концептуализацию идей и составление ежемесячных технических отчётов.",
      "experience.cert1.title": "Unity Android Game Development: Build 7 2D & 3D Games",
      "experience.cert1.issuer": "Udemy",
      "certificate.viewLink": "Посмотреть сертификат",
      "notfound.title": "Страница не найдена",
      "aitools.heading": "ИИ-инструменты",
      "aitools.intro": "Проекты, созданные с интеграцией ИИ в рабочий процесс разработки, демонстрирующие мою способность применять технологии ИИ в реальных решениях.",
      "aitools.editToggle": "Редактировать страницу",
      "aitools.pomodoro.title": "Таймер Помодоро",
      "aitools.pomodoro.desc": "Таймер продуктивности с настраиваемыми циклами работы и отдыха. Оптимизирует сессии концентрации с интервалами 25 минут работы и 5 минут отдыха.",
      "aitools.meapp.title": "me_app — Трекер личной жизни",
      "aitools.meapp.desc": "Комплексное мобильное приложение для отслеживания и управления личной жизнью. Разработано на React Native и Firebase с синхронизацией в реальном времени и архитектурой offline-first.",
      "aitools.meapp.f1.title": "Трекер одежды",
      "aitools.meapp.f1.desc": "Управление гардеробом с фотодокументацией и детальной статистикой использования",
      "aitools.meapp.f2.title": "Трекер тренировок",
      "aitools.meapp.f2.desc": "Более 40 встроенных упражнений с настраиваемыми шаблонами и отслеживанием сессий",
      "aitools.meapp.f3.title": "Синхронизация в реальном времени",
      "aitools.meapp.f3.desc": "Мультиустройственная синхронизация в реальном времени через Firebase",
      "aitools.meapp.f4.title": "Offline-first",
      "aitools.meapp.f4.desc": "Локальный кэш SQLite с автоматической облачной синхронизацией",
      "aitools.meapp.techLabel": "Технологии",
      "contact.heading": "Контакты",
      "contact.subtitle": "Открыт для предложений о работе и сотрудничества. Давайте свяжемся.",
      "contact.download": "Скачать резюме",
      "contact.linkedin": "LinkedIn",
      "contact.github": "GitHub",
      "contact.email": "Эл. почта",
      "editor.playgroundBanner": "Песочница",
      "editor.adminBanner": "Режим администратора",
      "editor.general": "Общие",
      "editor.block": "Блок",
      "editor.outline": "Структура",
      "editor.colors": "Цвета",
      "editor.fonts": "Шрифты",
      "editor.images": "Изображения",
      "editor.headingFont": "Шрифт заголовков",
      "editor.bodyFont": "Шрифт текста",
      "editor.profilePhoto": "Фото профиля",
      "editor.layoutStyle": "Макет и стиль",
      "editor.content": "Содержимое",
      "editor.save": "Сохранить",
      "editor.apply": "Применить",
      "editor.reset": "Сбросить",
      "editor.cancel": "Отмена",
      "editor.export": "Экспорт",
      "editor.import": "Импорт",
      "editor.sidebarSettings": "Боковая панель",
      "editor.exit": "Выйти из режима редактирования",
      "editor.undo": "Отменить",
      "editor.redo": "Повторить",
      "editor.addBlockHere": "Добавить блок здесь",
      "editor.moveUp": "Переместить блок вверх",
      "editor.moveDown": "Переместить блок вниз",
      "editor.duplicate": "Дублировать блок",
      "editor.delete": "Удалить блок",
      "editor.selectBlock": "Выбрать",
      "editor.reorderBlock": "Изменить порядок блока: нажмите и удерживайте, затем перетащите",
      "editor.blockDeleted": "Блок удалён",
      "editor.outlineEmpty": "На этой странице пока нет блоков.",
      "editor.noBlockSelected": "Нажмите на блок на странице, чтобы изменить его",
      "editor.resetTitle": "Сбросить всё?",
      "editor.resetMessage": "Это отменит все изменения без возможности восстановления.",
      "editor.imageInstructions": "Добавьте файл в public/images/, затем перезагрузите страницу, чтобы увидеть его.",
      "editor.unsupportedBrowser": "Для редактирования нужен более новый мобильный браузер. Откройте эту страницу на компьютере или обновите браузер, чтобы попробовать.",
      "editor.importParseError": "Этот файл не является допустимым JSON. Изменения не внесены.",
      "editor.importShapeError": "Этот JSON не является конфигурацией сайта — требуются meta, theme (colors, fonts, sizes), как минимум одна страница, i18n.es и sidebar. Изменения не внесены.",
      "editor.storageError": "Не удалось записать в хранилище браузера — конфигурация может быть слишком большой, либо хранилище заблокировано. Изменения не внесены.",
      "editor.pickBlock": "Добавить блок",
      "editor.close": "Закрыть",
      "editor.categoryAll": "Все",
      "editor.categoryText": "Текст",
      "editor.categoryContent": "Содержимое",
      "editor.categoryMedia": "Медиа",
      "editor.categoryLayout": "Макет",
      "editor.categoryInteractive": "Интерактив",
      "editor.panelLabel": "Редактор",
      "editor.expandCollapse": "Развернуть или свернуть редактор",
      "custom.title_mm6xjra1": "SKILLS UNIPILOTO",
      "custom.subtitle_mm6xkn18": "Университет Пилото де Колумбия",
      "custom.description_mm6xl2h9": "Разработал полноценное веб-приложение для сбора, визуализации и управления данными пользователей, поставив функциональное решение с панелью администратора за один месяц.",
      "custom.role_mm6y0lbl": "Стажёр — Разработчик",
      "custom.company_mm6y2c7d": "Университет Пилото де Колумбия",
      "custom.description_mm6y3wp7": "Разработал ключевые игровые функции, включая пользовательские настройки, меню, игровую механику, анимации и рефакторинг кода на Unity и C#.\nИсправил унаследованные баги проекта и провёл первые успешные тесты на мобильных устройствах.\nСоставил технические отчёты и рабочие документы, фиксирующие прогресс проекта.",
      "custom.company_mm6y5uzp": "Университет Пилото де Колумбия",
      "custom.description_mm6y6nbb": "Создал функциональное веб-приложение за один месяц с возможностями поиска, управления данными и визуализации.\nРеализовал панель администратора с ролевой аутентификацией для администраторов и менеджеров с использованием HTML, CSS, React, Node.js, Express.js и MySQL.",
      "custom.role_mm6y6u3p": "Full Stack веб-разработчик"
    }
  }
};

export default siteConfig;
